import { Button, ConfigProvider, Form, Input, Select, SelectProps, Space } from 'antd';

import React, { useEffect, useRef, useState } from 'react';

import bgsearch from '/public/sliders/searchdoctor.png';
import axios from 'axios';
import { Link, router, usePage } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import Dropdown from '@/Components/Dropdown';
import { motion } from 'framer-motion';
import { SearchFavorite1 } from 'iconsax-react';



export default function Specialistdoctors({ departments }: any) {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [datasearch, setDatasearch] = useState<SelectProps['options']>([]);
    const [valuesearch, setValuesearch] = useState<string>();
    const { currentRoute }: string | any = usePage().props;

    const [isVisible, setisVisible] = useState(false);
    const fadeUpRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entery]) => {
                setisVisible(entery.isIntersecting)
            },
            { threshold: .1 }
        );

        if (fadeUpRef.current) {
            observer.observe(fadeUpRef.current)
        }

        return () => {
            if (fadeUpRef.current) {

                observer.unobserve(fadeUpRef.current)
            }
        }
    }, [])

    const handleSearch = (newValue: string) => {
        if (newValue.trim() === '') {
            setDatasearch([]); // Clear options if input is empty
            return;
        }

        fetch(newValue, (data) => setDatasearch(data));
    };

    const handleChange = (value: string) => {

        setValuesearch(value);
    };


    const fetch = async (value: string, callback: (data: { value: string; text: string }[]) => void) => {

        try {
            const response = await axios.get(route('client.specialdoctor.search', { locale: i18n.language, value: value }));
            const data = response.data;
            // Transform the response into the format expected by the Select component
            const formattedData = data.map((doctor: { slug: string; name: string }) => ({
                value: doctor.slug,
                text: doctor.name,
            }));

            callback(formattedData);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            callback([]); // Pass an empty array if an error occurs
        }
    };




    const listselectDepartment: any = [];
    departments.map((department: any) =>
        listselectDepartment.push({ value: department.slug, label: department.title[i18n.language] })
    );

    const [textchangedepartment, settextchangedepartment] = useState(listselectDepartment[0]?.value);

    const handleChangedepartment = (value: string) => {
        settextchangedepartment(value);
    };

    useEffect(() => {

        settextchangedepartment(listselectDepartment.length > 0 ? listselectDepartment[0].value : [])

    }, [i18n.language])

    const onFinish = async (values: any) => {
        setLoading(true)
        router.get(route('client.specialdoctor.doctors', { locale: i18n.language }), { department: textchangedepartment, doctor: values.doctorname })

    };

    return (
        <div

            className={`m-5 p-5 flex justify-center items-center flex-col bg-no-repeat bg-cover object-center `}
            // style={{ backgroundImage: `url('${bgsearch}')` }}
        >
            <h2
                ref={fadeUpRef}
                className={`mt-10 p-4 font-extrabold text-sm lg:text-base  border-2 mb-2 rounded-full ${isVisible ? 'animate-fadeup' : 'opacity-0'} flex items-center bg-custom-dark-blue border-white text-white hover:bg-[#38b6ffc7] `}>
                <SearchFavorite1 size="24" color="white" />
                {t('form.searchdoctor')}</h2>
            <div
                className="p-5 rounded-xl bg-glass-white shadow-glass backdrop-blur-sm border-[1px] border-solid border-white w-full max-w-[700px]"

            >
                <Form
                    name="complex-form"
                    layout="vertical"
                    onFinish={onFinish}
                    className="flex flex-col items-center"
                >

                    <ConfigProvider
                        theme={{
                            components: {
                                Select: {

                                    optionActiveBg: '#e6f4ff',
                                    optionSelectedBg: '#38b6ff',
                                    optionSelectedColor: 'white'

                                },
                            },
                            token: {
                                fontSizeLG : 14,

                              },
                        }}
                    >

                        <Form.Item label={<p className='text-sm lg:text-base font-bold text-custom-dark-blue font-sans'>{t('form.department')}</p>}
                            className='w-[80%] font-sans'
                        >

                            <Select
                            direction={i18n.language === 'ar'? 'rtl' : 'ltr' }
                            size='large'
                                value={textchangedepartment}
                                style={{ width: '100%' }}
                                onChange={handleChangedepartment}
                                options={listselectDepartment}
                                className='font-sans'
                            />

                        </Form.Item>

                    </ConfigProvider>
                    <Form.Item label={<p className='text-sm lg:text-base font-bold text-custom-dark-blue font-sans'>{t('form.doctor')}</p>}
                    className='w-[80%] relative'>
                        <Form.Item name={'doctorname'} className='m-0'>

                            <Input

                                placeholder={t('form.specialdoctor_like')}
                                className="rounded-lg border-[#D9D9D9] py-1 dark:bg-[#141414] dark:text-white font-sans text-sm lg:text-base "
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                        </Form.Item>
                        {(datasearch && datasearch.length > 0) &&
                            <div className="w-[100%] bg-white rounded p-2 absolute z-50">
                                {datasearch.map(doctor => (
                                    <Link
                                        key={doctor.value}
                                        href={route('client.specialdoctor.show', { locale: i18n.language, slug: doctor.value })}
                                        className="block hover:bg-gray-100 p-2 rounded"
                                    >
                                        {doctor.text}
                                    </Link>
                                ))}
                            </div>
                        }
                    </Form.Item>
                    <Form.Item colon={false}>
                        <Button  className='p-5 rounded-full font-sans text-sm lg:text-base hover:!text-white hover:!border-white !bg-white !border-custom-dark-blue hover:!bg-custom-dark-blue dark:!bg-black dark:hover:!bg-custom-dark-blue' htmlType="submit" disabled={loading}>
                            {t('btn.search')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
